import { render, staticRenderFns } from "./CustomTabsSort.vue?vue&type=template&id=7d8f1948&scoped=true"
import script from "./CustomTabsSort.vue?vue&type=script&lang=js"
export * from "./CustomTabsSort.vue?vue&type=script&lang=js"
import style0 from "./CustomTabsSort.vue?vue&type=style&index=0&id=7d8f1948&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8f1948",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d8f1948')) {
      api.createRecord('7d8f1948', component.options)
    } else {
      api.reload('7d8f1948', component.options)
    }
    module.hot.accept("./CustomTabsSort.vue?vue&type=template&id=7d8f1948&scoped=true", function () {
      api.rerender('7d8f1948', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget/deWidget/CustomTabsSort.vue"
export default component.exports